<template>
  <!--xs: phone, sm: pad, md: pc, lg: 2k-pc, xl: 4k-pc-->
  <nav class="header">
    <!-- 顶部导航 -->
    <div class="container">
      <ul class="container-left-ul">
        <img class="logoimg" @click="GoNewPage('Dashboard')" src="@/assets/headerLogo.png" />
        <ul class="menu container-left-li">
          <li
            v-for="(item) in items"
            :index="item.index"
            :key="item.index"
            v-show="authw(item.auth,item.nlogin)"
            :class="item.ischoose ? 'lichoosed' : '' "
          >
            <template v-if="item.subs">
              <a>{{ item.title }}</a>
              <ul class="submenu">
                <li v-for="subItem in item.subs" :index="subItem.index" :key="subItem.index" v-show="authw(subItem.auth)">
                  <!-- <a href="#">{{ subItem.title }}</a> -->
                  <a v-if="subItem.url" :href="subItem.url" target="_blank">{{ subItem.title }}</a>
                  <a v-if="!subItem.url" @click="GoNewPage(subItem.index)" target="_blank">{{ subItem.title }}</a>
                </li>
              </ul>
            </template>
            <template v-else>
              <a v-if="item.url" :href="item.url" target="_blank">{{ item.title }}</a>
              <a v-if="!item.url" @click="GoNewPage(item.index)" target="_blank">{{ item.title }}</a>
            </template>
          </li>
        </ul>
      </ul>
      <ul class="container-right-ul">
        <a-dropdown v-if="isLogin" :trigger="['click']" class="headerName">          
          <a class="ant-dropdown-link" href="#" >
            {{username}}
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <a @click="LoginOut()">Login out</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <a-avatar v-if="isLogin" style="color: #f56a00; backgroundColor: #fde3cf" class="headerAvatar">{{username.substring(0,1)}}</a-avatar>
        <img v-if="!isLogin" class="LoginButton" @click="Gologin()" src="@/assets/svg/登录.svg">
        <a-dropdown :trigger="['click']" class="headerLanguage">          
          <a class="ant-dropdown-link" href="#" >
            <SwapOutlined />
          </a>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <a @click="setLang('en_US')">English</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="setLang('zh_CN')">中文</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </ul>
    </div>
  </nav>
</template>
<script>
import { useI18n } from "@/i18nPlugin";
import { store } from "@/store";
import { useRouter } from 'vue-router';
export default {
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const items = [
      {
        icon: "el-icon-s-home",
        index: "dashboard",
        title: i18n.$t('HeaderDashboard'),
        ischoose: false,
        nlogin: false,
        auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1","ROLE_aftersale2"]
      },
      {
        icon: "el-icon-s-home",
        index: "BBS",
        title: i18n.$t('HeaderBBS'),
        ischoose: false,
        nlogin: false,
        auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1","ROLE_aftersale2"]
      },
      {
        icon: "el-icon-s-home",
        index: "ToolVersionUpdate",
        title: i18n.$t('HeaderToolVersionUpdate'),
        ischoose: false,
        nlogin: true,
        auth: ["ROLE_admin","ROLE_developer"]
      },
      {
        icon: "el-icon-document",
        index: "More",
        title: i18n.$t('HeaderMore'),
        ischoose: false,
        nlogin: true,
        auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1","ROLE_aftersale2"],
        subs: [
          {
            index: "AccountManage",
            title: i18n.$t('HeaderAccountManage'),
            ischoose: false,
            nlogin: true,
            auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1"]
          },
          {
            index: "LoginInfo",
            title: i18n.$t('HeaderLoginInfo'),
            ischoose: false,
            nlogin: true,
            auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1","ROLE_aftersale2"]
          },
          {
            index: "SystemNotice",
            title: i18n.$t('HeaderSystemNotice'),
            ischoose: false,
            nlogin: true,
            auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1"]
          },
          {
            index: "ToolsError",
            title: i18n.$t('HeaderToolsError'),
            ischoose: false,
            nlogin: true,
            auth: ["ROLE_admin","ROLE_developer"]
          },
          {
            index: "NormalSetting",
            title: i18n.$t('HeaderNormalSetting'),
            ischoose: false,
            nlogin: true,
            auth: ["ROLE_admin","ROLE_developer"]
          },
          {
            index: "VersionControl",
            title: i18n.$t('HeaderVersionControl'),
            ischoose: false,
            nlogin: true,
            auth: ["ROLE_admin","ROLE_developer","ROLE_aftersale1","ROLE_aftersale2"]
          },
        ]
      },
    ]
    const setLang = (value) => {
      store.commit('setLang', value);
      localStorage.setItem('setLang', value);
      i18n.locale.value = value;
      history.go(0)
    }
    const LoginOut = () => {
      localStorage.removeItem("userName_ats");
      localStorage.removeItem("userToken");
      localStorage.removeItem("Group");
      localStorage.removeItem("expirationDate");
      localStorage.removeItem("isLogin");
      router.push('/ATS/Login');
    }

    const Gologin = () => {
      router.push('/ATS/Login');
    }
    return { i18n, setLang, items, LoginOut, Gologin };
  },
  name: "Header",
  data () {
    return {
      token: '',
      userid: '',
      username: localStorage.getItem("userName_ats"),
      Group: localStorage.getItem("Group"),
      isLogin: localStorage.getItem("isLogin"),
      // username: "Snoppy",
    };
  },
  watch: {
    $route (to, from) {
      // console.log(to,from)
      this.items.forEach((item) => {
        item.ischoose = false;
        if (('/' + item.index) == to.path) {
          item.ischoose = true;
        }
      });
    }
  },
  created () {
    this.items.forEach((item) => {
      item.ischoose = false;
      // console.log(this.$route.path)
      if (('/' + item.index) == this.$route.path) {
        item.ischoose = true;
      }
      if (this.$route.path == '/TechnologyCommunity') {
        item.ischoose = true;
      }
    });
    this.searchcontent = this.$route.query.searchcontent
  },
  computed: {
    onRoutes () {
      return this.$route.path.replace("/ATS", "");
    }
  },
  methods: {
    GoNewPage (url) {
      this.$router.push({ path: '/ATS/' + url });
    },
    authw: function(auth,nlogin) {
        let w = false;
        if(auth.includes(this.Group)){
          w = true;
        }
        if((this.isLogin == undefined || this.isLogin == false) && nlogin == true){
          w = false;
        }
        if(nlogin == false) {
          w = true;
        }
        // console.log(auth)
        return w;
    }
  },
};
</script>

<style scoped>
  .header {
    color: #353535;
    background: #ffffff;
    height: 84px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.04);
    width: 100%;
    top: 0;
  }

  .container {
    width: 1120px;
    margin-right: auto;
    margin-left: auto;
  }
  .container-left-ul .logo {
    font-family: Arial-Black;
    font-size: 36px;
    color: #353535;
    float: left;
    margin-left: 8px;
    width: 90PX;
    line-height: 88px;
    font-weight: 1000;
  }

  .logoimg {
    float: left;
    cursor: pointer;
    /* position: absolute; */
    width: 220px;
    margin-top: 30px;
  }

  .menu {
    height: 84px;
    opacity: 1;
    display: inline-flex;
    margin-left: -360px;
  }

  .menu > li {
    background: #ffffff;
    float: left;
    position: relative;
    list-style: none;
    margin-left: 54px;
  }

  .menu a {
    display: block;
    text-align: center;
    font-size: 16px;
    color: #353535;
    line-height: 80px;
    text-transform: uppercase;
    text-decoration: none;
    font-family: STHeitiSC-Medium;
  }

  .menu li:hover > a {
    color: #03a0d6;
    border-bottom: 4px solid #03a0d6;
  }

  .submenu {
    position: absolute;
    width: 258px;
    /* left: 50%; */
    margin-left: -70px;
    line-height: 61px;
    z-index: 9999;
  }

  .submenu li {
    background-color: white;
    height: 61px;
    position: relative;
    overflow: hidden;
  }

  .submenu > li > a {
    font-size: 16px;
    color: #353535;
    text-align: left;
    margin-left: 30px;
    line-height: 61px;
  }

  .submenu li:hover {
    border-bottom: none;
  }

  .submenu li:hover > a {
    color: #03a0d6;
  }

  .submenu > li::after {
    position: absolute;
    top: -125%;
    height: 100%;
    width: 100%;
  }

  .submenu, .submenu li {
    opacity: 0;
    visibility: hidden;
  }

  .submenu li {
    transition: 0.2s ease transform;
  }

  .menu > li:hover .submenu, .menu > li:hover .submenu li {
    opacity: 1;
    visibility: visible;
  }

  li {
    height: 100%;
    cursor: pointer;
  }

  .container-right-ul {
    line-height: 88px;
    margin-left: 792px;
    margin-top: -97px;
  }
  .headerAvatar {
    float: right;
    margin-top: 30px;
    /* margin-left: 10px; */
  }
  .headerName {
    float: right;
    margin-right: 10px;
    margin-left: 30px;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    font-size: 16px;
    font-weight: bold;
    color: black;
    text-decoration: none;
  }
  .headerLanguage {
    float: right;
    margin-right: 25px;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    font-size: 16px;
    font-weight: bold;
    color: black;
    text-decoration: none;
  }
  .lichoosed a{
    color: #03a0d6 !important;
    border-bottom: 4px solid #03a0d6;
  }
  .LoginButton {
    cursor: pointer;
    width: 125px;
    height: 35px;
    float: right;
    margin-top: 27px;
  }
</style>
